const isProd = process.env.NODE_ENV === 'production';
/*     window.location.protocol + '//' + window.location.host + '/api' : 'https://localhost:44355/',*/
const config = {
  API_URL: isProd
    ? ('https://' + window.location.host + '/api/') : 'https://ozgndev04.itom.report/api/',

    /*   API_URL: process.env.NODE_ENV === 'production' ?
       'http://ozgnqs01.itom.report/api/' : 'https://localhost:44355/',*/
    /* API_URL: process.env.NODE_ENV === 'production' ?
       '0' : 'https://localhost:44355/',*/
  DEPLOY_URL: isProd
    ? 'https://ozgnqs01.itom.report/api/'
    : 'https://ozgndev04.itom.report/api/',
    /* API_URL: process.env.NODE_ENV === 'production' ?
        'https://www.ozg-digital.de/api/ : 'https://localhost:44355/',*/


  ICON_PANEL_API_URL: 'https://iconpanel.ozg-manager.site/api',   // aktuell: doppeltes /api nötig
  ICON_PANEL_APP_URL: 'https://iconpanel.ozg-manager.site/',    // aktuell: doppeltes /api nötig
  VERSION: '2.0.1',
  APP_KEY: 'c2790ece23bcb7656ffef842d9f51054',
};

console.log('[ozg-system config]', config);

export default config;